export class AudioPlayer {
  public static async play(src: string) {
    return new Promise<void>((resolve) => {
      const audio = new Audio(src);
      audio.onended = () => resolve();
      audio.play();
    });
  }
}
